import { render, staticRenderFns } from "./donut-charts.vue?vue&type=template&id=179a6965&"
import script from "./donut-charts.vue?vue&type=script&lang=js&"
export * from "./donut-charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports